// Rhebus color palette
const white = '#ffffff';
const darkgrey = '#352f39';
const brown = '#483f47';
const red = '#bf1b47';
const lightgrey = '#e4e0e2';
const yellow = '#fad962';
const lightblue = '#b0dde4';
const blue = '#4ea9dd';

const rhebusBrown = {
  50: '#000F14',
  100: '#002D3D',
  200: '#003C51',
  300: '#01597A',
  400: '#0177A2',
  500: '#483f47', // rhebus
  600: '#01B3F4',
  700: '#20C3FE',
  800: '#4ea9dd',
  900: '#5DD3FE',
  A100: '#85DEFE',
  A200: '#5DD3FE',
  A400: '#D6F4FF',
  A700: '#EBFAFF',
  darkText: [900, 900, 'A100', 'A200']
};

const rhebusBlue = {
  50: '#000F14',
  100: '#002D3D',
  200: '#003C51',
  300: '#01597A',
  400: '#0177A2',
  500: '#b0dde4', // rhebus
  600: '#01B3F4',
  700: '#20C3FE',
  800: '#34C8FE',
  900: '#5DD3FE',
  A100: '#85DEFE',
  A200: '#5DD3FE',
  A400: '#D6F4FF',
  A700: '#EBFAFF',
  darkText: [900, 900, 'A100', 'A200']
};

const stitchRed = {
  50: '#770411',
  100: '#9E0517',
  200: '#C6061C',
  300: '#DA071F',
  400: '#F8122C',
  500: '#f93147',
  600: '#FA6173',
  700: '#FB8896',
  800: '#FC9CA7',
  900: '#FDB0B9',
  A100: '#FDB0B9',
  A200: '#FEEBED',
  A400: '#FED7DC',
  A700: '#FEEBED',
  darkText: [50, 100, 'A100', 'A200']
};

const stitchGreen = {
  50: '#001410',
  100: '#002921',
  200: '#005241',
  300: '#006652',
  400: '#008F72',
  500: '#00ae8c',
  600: '#00E0B4',
  700: '#33FFD6',
  800: '#99FFEB',
  900: '#C2FFF3',
  A100: '#85FFE7',
  A200: '#0AFFCE',
  A400: '#00E0B4',
  A700: '#007A62',
  darkText: [50, 100, 'A100', 'A200']
};

export default (Vue) => {
  Vue.material.registerPalette('rhebus-blue', rhebusBlue);
  Vue.material.registerPalette('rhebus-brown', rhebusBrown);

  Vue.material.registerPalette('stitch-red', stitchRed);
  Vue.material.registerPalette('stitch-green', stitchGreen);

  Vue.material.registerTheme({
    'default': {
      primary: { color: 'blue-grey', hue: 900 },
      accent: { color: 'rhebus-blue', hue: 500 },
      warn: { color: 'stitch-red', hue: 500 },
      background: 'white'
    },

    'blue': {
      primary: 'rhebus-blue',
      accent: { color: 'rhebus-blue', hue: 800 }
    },

    'green': {
      primary: 'stitch-green',
      accent: { color: 'stitch-green', hue: 700 }
    },

    'red': {
      primary: 'stitch-red',
      accent: { color: 'stitch-red', hue: 400 }
    },

    'white-brown': {
      background: 'white',
      primary: 'white',
      accent: { color: 'rhebus-brown', hue: 500 }
    },

    'brown-white': {
      background: { color: 'rhebus-brown', hue: 500 },
      primary: { color: 'rhebus-brown', hue: 500 }
    },

    'rhebus-blue': {
      background: { color: 'rhebus-blue', hue: 500 },
      primary: { color: 'rhebus-blue', hue: 500 },
    }
  });

};



// WEBPACK FOOTER //
// ./src/config/theme.js